module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctag1"
  }, [_vm._v("In this book I follow the convention whereby audiological deafness is spelled with a lowercase “d,” to distinguish it from Deafness with an uppercase “D,” a reference to the culture and community of those with fluency in sign language.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-292aa093","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jenn_9781558616912_oeb_fm2_r1.vue
// module id = 69
// module chunks = 0